import Vue from 'vue'
import './plugins/axios'
  
import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
//import './main.css'
Vue.use(Buefy)

import ECharts from 'vue-echarts'
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, GaugeChart, LineChart } from "echarts/charts";
import {
    GridComponent,
} from "echarts/components";

use([BarChart,
    LineChart,
    GaugeChart,
    GridComponent,
    CanvasRenderer]);


// register globally (or you can do it locally)
Vue.component('v-chart', ECharts)



Vue.config.productionTip = false

// import App from './App.vue'
// new Vue({
//   render: h => h(App),
// }).$mount('#app')

import TransPoll from './components/TransPoll.vue'
import Cockpit from './components/Cockpit.vue'
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)
Vue.customElement('transformation-poll', TransPoll)
Vue.customElement('transformation-cockpit', Cockpit)
